import { getServerProps } from '../utilsV3/serverProps';
import _map from 'lodash/map';

import {
  CHECK_EMAIL_CONFIRMED_RESPONSE,
  SHOW_UNKNOWN_ERROR_OCCURED,
  HIDE_UNKNOWN_ERROR_OCCURED,
  SHOW_COUNTRY_NOT_SUPPORTED,
  HIDE_COUNTRY_NOT_SUPPORTED,
  UPDATE_BUSINESS_IMAGE_URLS,
  UPDATE_PPCC_STATUS,
} from '../componentsV3/partner/actionsPartner';

import {
  POST_ORGANIZER_UPDATE_ERROR,
  POST_ORGANIZER_UPDATE_SUCCESS,
  EDIT_ORGANIZER_UPDATE_ERROR,
  EDIT_ORGANIZER_UPDATE_SUCCESS,
  GET_ORGANIZER_UPDATES,
  GET_ORGANIZER_UPDATES_ERROR,
  GET_ORGANIZER_UPDATES_SUCCESS,
  DELETE_ORGANIZER_UPDATE_ERROR,
  DELETE_ORGANIZER_UPDATE_SUCCESS,
  INCREMENT_ORGANIZER_UPDATE_COUNT,
  DECREMENT_ORGANIZER_UPDATE_COUNT,
} from '../actions/actionsCommon';

const defaultState = {
  ...getServerProps(),
  receivableCurrency: _map(getServerProps().receivableCurrency, (currency) => {
    return {
      value: currency,
      displayValue: currency,
    };
  }),
  organizerUpdates: [],
  defaultOrganizerUpdate: {
    subject: '',
    text: [
      {
        type: 'p',
        children: [
          {
            text: '',
          },
        ],
      },
    ],
    status: 'ACTIVE',
  },
  postOrganizerUpdateError: false,
  editOrganizerUpdateError: false,
  getOrganizerUpdateError: false,
  deleteOrganizerUpdateError: false,
};

export default function application(state = defaultState, action = {}) {
  switch (action.type) {
    case CHECK_EMAIL_CONFIRMED_RESPONSE: {
      const isEmailConfirmed = action.payload === true;
      return {
        ...state,
        isEmailConfirmed,
      };
    }
    case SHOW_COUNTRY_NOT_SUPPORTED: {
      return {
        ...state,
        countryNotSupported: true,
      };
    }

    case HIDE_COUNTRY_NOT_SUPPORTED: {
      return {
        ...state,
        countryNotSupported: false,
      };
    }

    case SHOW_UNKNOWN_ERROR_OCCURED: {
      return {
        ...state,
        unknownError: true,
      };
    }

    case HIDE_UNKNOWN_ERROR_OCCURED: {
      return {
        ...state,
        unknownError: false,
      };
    }

    case UPDATE_BUSINESS_IMAGE_URLS: {
      return {
        ...state,
        businessImageUrls: {
          ...state.businessImageUrls,
          url: action.url,
        },
      };
    }

    case GET_ORGANIZER_UPDATES: {
      const organizerUpdateList = state.organizerUpdates ?? [];
      return {
        ...state,
        organizerUpdatesLoader: true,
        organizerUpdates: organizerUpdateList,
      };
    }

    case GET_ORGANIZER_UPDATES_ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        organizerUpdatesLoader: false,
        totalOrganizerUpdatesCount: 0,
        getOrganizerUpdateError: true,
      };
    }

    case GET_ORGANIZER_UPDATES_SUCCESS: {
      const { organizerUpdates, total } = action.payload;
      return {
        ...state,
        organizerUpdatesLoader: false,
        totalOrganizerUpdatesCount: total,
        organizerUpdates: state.organizerUpdates?.concat(organizerUpdates),
        getOrganizerUpdateError: false,
      };
    }

    case INCREMENT_ORGANIZER_UPDATE_COUNT: {
      const total = state.totalOrganizerUpdatesCount + 1;
      return {
        ...state,
        totalOrganizerUpdatesCount: total,
      };
    }

    case DECREMENT_ORGANIZER_UPDATE_COUNT: {
      const total =
        state.totalOrganizerUpdatesCount > 0
          ? state.totalOrganizerUpdatesCount - 1
          : 0;
      return {
        ...state,
        totalOrganizerUpdatesCount: total,
      };
    }

    case POST_ORGANIZER_UPDATE_ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        postOrganizerUpdateError: true,
      };
    }

    case POST_ORGANIZER_UPDATE_SUCCESS: {
      const { organizerUpdate } = action.payload;
      return {
        ...state,
        organizerUpdates: [organizerUpdate, ...state.organizerUpdates],
      };
    }

    case EDIT_ORGANIZER_UPDATE_ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        editOrganizerUpdateError: true,
      };
    }

    case EDIT_ORGANIZER_UPDATE_SUCCESS: {
      const { organizerUpdate } = action.payload;
      return {
        ...state,
        organizerUpdates: state.organizerUpdates.map((update) =>
          update.fou_id === organizerUpdate.fou_id ? organizerUpdate : update
        ),
      };
    }

    case DELETE_ORGANIZER_UPDATE_ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        deleteOrganizerUpdateError: true,
      };
    }

    case DELETE_ORGANIZER_UPDATE_SUCCESS: {
      const { updateId } = action.payload;
      return {
        ...state,
        organizerUpdates: state.organizerUpdates.filter(
          (update) => update.fou_id !== updateId
        ),
      };
    }

    case UPDATE_PPCC_STATUS: {
      return {
        ...state,
        ppccSetupStatus: action.ppccSetupStatus,
      };
    }

    default:
      return state;
  }
}
